import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { RoutePartCMRSignatureAgents } from '@shared/src/controllers/route/cmr/RoutePartCMRSignatureAgents';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { RouteCMRAgentPhaseExpandBaseDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentPhaseExpandBaseDto';
import { AlertService, HString } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-cmr-agent-actions-documentationsigning',
    templateUrl: './shared.external.cmr.agent.actions.documentationsigning.component.html',
    styleUrls: ['./shared.external.cmr.agent.actions.documentationsigning.component.scss']
})
export class SharedExternalCMRAgentActionsDocumentationSigningComponent implements OnInit {


    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteController: OpenRouteController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
    }

    public __uuidQR: string;
    @Input()
    public set uuidQR(value: string) {
        if (this.__uuidQR === value)
            return;
        this.__uuidQR = value;
        this.wellcome();
    }
    public get uuidQR(): string {
        return this.__uuidQR;
    }

    public __agent: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.__agent === value)
            return;
        this.__agent = value;
        this.wellcome();
    }
    public get agent(): RouteCMRAgents {
        return this.__agent;
    }

    
    public wellcome() {
        this.loadData();
    }

    @Output() allPhaseSigned = new EventEmitter<boolean>();

    public phases: RouteCMRAgentPhaseExpandBaseDto[];
    public currentPhase: RouteCMRAgentPhaseExpandBaseDto;
    public loadData(){
        if (!HString.isNullOrNullString(this.uuidQR) && RouteCMRAgentsEnum.isValid(this.agent)) {
            this.openRouteCMRController.getRouteCMRAgentPhaseToSigningByUUID(this.uuidQR, this.agent).subscribe(data => { 
                this.phases = data;
                if(this.phases != null && this.phases.length > 0){
                    this.currentPhase = this.phases[0];
                }else{
                    this.allPhaseSigned.next(true);
                }
            });
        }
    }

    public get signatureAgent(): RoutePartCMRSignatureAgents {
        if (this.agent === RouteCMRAgents.driver)
            return RoutePartCMRSignatureAgents.driver;
        if (this.agent === RouteCMRAgents.sender)
            return RoutePartCMRSignatureAgents.sender;
        if (this.agent === RouteCMRAgents.consignee)
            return RoutePartCMRSignatureAgents.consignee;
        return null;
    }
   
    public onPhaseSigned() {
        this.loadData();
    }

}
